// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// versions:
//   protoc-gen-ts_proto  v2.6.1
//   protoc               unknown
// source: configd/entitlement.proto

/* eslint-disable */
import { BinaryReader, BinaryWriter } from "@bufbuild/protobuf/wire";
import { SbpModel, sbpModelFromJSON, sbpModelToJSON } from "../models/auth";
import {
  EntitlementLevel,
  entitlementLevelFromJSON,
  entitlementLevelToJSON,
  EntitlementUsageType,
  entitlementUsageTypeFromJSON,
  entitlementUsageTypeToJSON,
} from "../models/global";

export const protobufPackage = "configd";

/**
 * GetEntitlementUsageRequest.
 *
 * This asks for a summary of an organization's entitlements usage and compliance.
 */
export interface GetEntitlementUsageRequest {
  /**
   * Calculate the entitlement usage and compliance based on nodes in blueprint
   * if set to true. Default is always calculate based on bound physical devices.
   */
  nodes: boolean;
  /** Calculate the entitlement usage and compliance based on  usage type */
  usageType: EntitlementUsageType;
}

/**
 * GetEntitlementUsageResponse.
 *
 * This is a summary of the entitlements of the caller's organization and their usage.
 */
export interface GetEntitlementUsageResponse {
  /** Summary of an organization's entitlement usage per entitlement level sorted in decreasing level. */
  usages: EntitlementUsage[];
  /** EntitlementUsage by product. */
  usageByPid: EntitlementUsageByPID[];
}

/** EntitlementUsageByPID */
export interface EntitlementUsageByPID {
  pid: string;
  /** Number of entitlements granted for this PID. */
  totalEntitled: number;
  /** Number of entitlements used, including the ones lent. */
  totalUsed: number;
  /**
   * Number of entitlements  available for use after allocation.
   * available_balance = total_entitled - total_used
   */
  availableBalance: number;
  /** Number of entitlement that are required to be compliant. */
  required: number;
}

/**
 * Entitlement uage.
 *
 * This is a summary of the organization's entitlement usage at a given level.
 */
export interface EntitlementUsage {
  /**
   * An entitlement is a grant from a subscription to use a 'quantity' of devices
   * of a certain 'model' in a fabric of this entitlement 'level'.
   */
  level: EntitlementLevel;
  /**
   * Number entitlements at this level available for use after allocation regardless of model.
   * available_balance = total_entitled - allocated_to - lent
   *
   * @deprecated
   */
  availableBalance: number;
  /**
   * Number of entitlements granted at this level regardless of model.
   *
   * @deprecated
   */
  totalEntitled: number;
  /**
   * Number entitlements of this level bound to fabrics at this level regardless of model.
   * allocated_to = sum(fabric_usage.allocated).
   */
  allocatedTo: number;
  /** Number of entitlements borrowed from a higher level used in fabrics at this level. */
  borrowed: EntitlementsShared[];
  /** Number of entitlements of this level lent to fabrics at a lower level. */
  lent: EntitlementsShared[];
  /** Summarizes how entitlements are used by each fabric at the given level. */
  fabricUsage: EntitlementFabricUsage[];
}

/**
 * Entitlements shared.
 *
 * This is a summary of entitlements lent or borrowed to or from a given entitlement level.
 */
export interface EntitlementsShared {
  /** Level from which entitlements are lent or borrowed. */
  level: EntitlementLevel;
  /** Count of entitlements lent or borrowed. */
  count: number;
}

/**
 * Fabric usage of entitlements.
 *
 * This summarizes a fabric's usage of entitlements.
 */
export interface EntitlementFabricUsage {
  /** Identifier of fabric using entitlements. */
  fabricId: string;
  /** Name of fabric using entitlements. */
  fabricName: string;
  /**
   * Level of fabric using entitlements.
   *
   * @deprecated
   */
  level: EntitlementLevel;
  /** Usage grouped by device model. */
  usage: EntitlementModelUsage[];
}

/**
 * Fabric usage of models.
 *
 * This is a summary of a fabric's usage of entitlements of certain device model.
 */
export interface EntitlementModelUsage {
  /**
   * Model of device.
   *
   * @deprecated
   */
  model: SbpModel;
  /** PID of the entitlement */
  pid: string;
  /**
   * Total number of devices of this model bound to this fabric.
   * Total Bound = Allocated + Borrowed + Needed
   *
   * @deprecated
   */
  totalBound: number;
  /** Number of entitlements of this model of this level bound to this fabric. */
  allocated: number;
  /**
   * Number of entitlements of this model borrowed from a higher level bound to this fabric.
   *
   * @deprecated
   */
  borrowed: number;
  /** Number of devices of this model bound to this fabric that are not covered by any subscription. */
  needed: number;
  /**
   * Whether or not this fabric is compliant with number of devices of this model used.
   *
   * @deprecated
   */
  compliant: boolean;
}

function createBaseGetEntitlementUsageRequest(): GetEntitlementUsageRequest {
  return { nodes: false, usageType: 0 };
}

export const GetEntitlementUsageRequest: MessageFns<GetEntitlementUsageRequest> = {
  encode(message: GetEntitlementUsageRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.nodes !== false) {
      writer.uint32(8).bool(message.nodes);
    }
    if (message.usageType !== 0) {
      writer.uint32(16).int32(message.usageType);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): GetEntitlementUsageRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseGetEntitlementUsageRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break;
          }

          message.nodes = reader.bool();
          continue;
        }
        case 2: {
          if (tag !== 16) {
            break;
          }

          message.usageType = reader.int32() as any;
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): GetEntitlementUsageRequest {
    return {
      nodes: isSet(object.nodes) ? globalThis.Boolean(object.nodes) : false,
      usageType: isSet(object.usageType) ? entitlementUsageTypeFromJSON(object.usageType) : 0,
    };
  },

  toJSON(message: GetEntitlementUsageRequest): unknown {
    const obj: any = {};
    if (message.nodes !== false) {
      obj.nodes = message.nodes;
    }
    if (message.usageType !== 0) {
      obj.usageType = entitlementUsageTypeToJSON(message.usageType);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<GetEntitlementUsageRequest>, I>>(base?: I): GetEntitlementUsageRequest {
    return GetEntitlementUsageRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<GetEntitlementUsageRequest>, I>>(object: I): GetEntitlementUsageRequest {
    const message = createBaseGetEntitlementUsageRequest();
    message.nodes = object.nodes ?? false;
    message.usageType = object.usageType ?? 0;
    return message;
  },
};

function createBaseGetEntitlementUsageResponse(): GetEntitlementUsageResponse {
  return { usages: [], usageByPid: [] };
}

export const GetEntitlementUsageResponse: MessageFns<GetEntitlementUsageResponse> = {
  encode(message: GetEntitlementUsageResponse, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    for (const v of message.usages) {
      EntitlementUsage.encode(v!, writer.uint32(802).fork()).join();
    }
    for (const v of message.usageByPid) {
      EntitlementUsageByPID.encode(v!, writer.uint32(1602).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): GetEntitlementUsageResponse {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseGetEntitlementUsageResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 100: {
          if (tag !== 802) {
            break;
          }

          message.usages.push(EntitlementUsage.decode(reader, reader.uint32()));
          continue;
        }
        case 200: {
          if (tag !== 1602) {
            break;
          }

          message.usageByPid.push(EntitlementUsageByPID.decode(reader, reader.uint32()));
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): GetEntitlementUsageResponse {
    return {
      usages: globalThis.Array.isArray(object?.usages)
        ? object.usages.map((e: any) => EntitlementUsage.fromJSON(e))
        : [],
      usageByPid: globalThis.Array.isArray(object?.usageByPid)
        ? object.usageByPid.map((e: any) => EntitlementUsageByPID.fromJSON(e))
        : [],
    };
  },

  toJSON(message: GetEntitlementUsageResponse): unknown {
    const obj: any = {};
    if (message.usages?.length) {
      obj.usages = message.usages.map((e) => EntitlementUsage.toJSON(e));
    }
    if (message.usageByPid?.length) {
      obj.usageByPid = message.usageByPid.map((e) => EntitlementUsageByPID.toJSON(e));
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<GetEntitlementUsageResponse>, I>>(base?: I): GetEntitlementUsageResponse {
    return GetEntitlementUsageResponse.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<GetEntitlementUsageResponse>, I>>(object: I): GetEntitlementUsageResponse {
    const message = createBaseGetEntitlementUsageResponse();
    message.usages = object.usages?.map((e) => EntitlementUsage.fromPartial(e)) || [];
    message.usageByPid = object.usageByPid?.map((e) => EntitlementUsageByPID.fromPartial(e)) || [];
    return message;
  },
};

function createBaseEntitlementUsageByPID(): EntitlementUsageByPID {
  return { pid: "", totalEntitled: 0, totalUsed: 0, availableBalance: 0, required: 0 };
}

export const EntitlementUsageByPID: MessageFns<EntitlementUsageByPID> = {
  encode(message: EntitlementUsageByPID, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.pid !== "") {
      writer.uint32(10).string(message.pid);
    }
    if (message.totalEntitled !== 0) {
      writer.uint32(80).uint32(message.totalEntitled);
    }
    if (message.totalUsed !== 0) {
      writer.uint32(160).uint32(message.totalUsed);
    }
    if (message.availableBalance !== 0) {
      writer.uint32(240).uint32(message.availableBalance);
    }
    if (message.required !== 0) {
      writer.uint32(320).uint32(message.required);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): EntitlementUsageByPID {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseEntitlementUsageByPID();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.pid = reader.string();
          continue;
        }
        case 10: {
          if (tag !== 80) {
            break;
          }

          message.totalEntitled = reader.uint32();
          continue;
        }
        case 20: {
          if (tag !== 160) {
            break;
          }

          message.totalUsed = reader.uint32();
          continue;
        }
        case 30: {
          if (tag !== 240) {
            break;
          }

          message.availableBalance = reader.uint32();
          continue;
        }
        case 40: {
          if (tag !== 320) {
            break;
          }

          message.required = reader.uint32();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): EntitlementUsageByPID {
    return {
      pid: isSet(object.pid) ? globalThis.String(object.pid) : "",
      totalEntitled: isSet(object.totalEntitled) ? globalThis.Number(object.totalEntitled) : 0,
      totalUsed: isSet(object.totalUsed) ? globalThis.Number(object.totalUsed) : 0,
      availableBalance: isSet(object.availableBalance) ? globalThis.Number(object.availableBalance) : 0,
      required: isSet(object.required) ? globalThis.Number(object.required) : 0,
    };
  },

  toJSON(message: EntitlementUsageByPID): unknown {
    const obj: any = {};
    if (message.pid !== "") {
      obj.pid = message.pid;
    }
    if (message.totalEntitled !== 0) {
      obj.totalEntitled = Math.round(message.totalEntitled);
    }
    if (message.totalUsed !== 0) {
      obj.totalUsed = Math.round(message.totalUsed);
    }
    if (message.availableBalance !== 0) {
      obj.availableBalance = Math.round(message.availableBalance);
    }
    if (message.required !== 0) {
      obj.required = Math.round(message.required);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<EntitlementUsageByPID>, I>>(base?: I): EntitlementUsageByPID {
    return EntitlementUsageByPID.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<EntitlementUsageByPID>, I>>(object: I): EntitlementUsageByPID {
    const message = createBaseEntitlementUsageByPID();
    message.pid = object.pid ?? "";
    message.totalEntitled = object.totalEntitled ?? 0;
    message.totalUsed = object.totalUsed ?? 0;
    message.availableBalance = object.availableBalance ?? 0;
    message.required = object.required ?? 0;
    return message;
  },
};

function createBaseEntitlementUsage(): EntitlementUsage {
  return { level: 0, availableBalance: 0, totalEntitled: 0, allocatedTo: 0, borrowed: [], lent: [], fabricUsage: [] };
}

export const EntitlementUsage: MessageFns<EntitlementUsage> = {
  encode(message: EntitlementUsage, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.level !== 0) {
      writer.uint32(8).int32(message.level);
    }
    if (message.availableBalance !== 0) {
      writer.uint32(80).uint32(message.availableBalance);
    }
    if (message.totalEntitled !== 0) {
      writer.uint32(88).uint32(message.totalEntitled);
    }
    if (message.allocatedTo !== 0) {
      writer.uint32(96).uint32(message.allocatedTo);
    }
    for (const v of message.borrowed) {
      EntitlementsShared.encode(v!, writer.uint32(802).fork()).join();
    }
    for (const v of message.lent) {
      EntitlementsShared.encode(v!, writer.uint32(810).fork()).join();
    }
    for (const v of message.fabricUsage) {
      EntitlementFabricUsage.encode(v!, writer.uint32(8002).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): EntitlementUsage {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseEntitlementUsage();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break;
          }

          message.level = reader.int32() as any;
          continue;
        }
        case 10: {
          if (tag !== 80) {
            break;
          }

          message.availableBalance = reader.uint32();
          continue;
        }
        case 11: {
          if (tag !== 88) {
            break;
          }

          message.totalEntitled = reader.uint32();
          continue;
        }
        case 12: {
          if (tag !== 96) {
            break;
          }

          message.allocatedTo = reader.uint32();
          continue;
        }
        case 100: {
          if (tag !== 802) {
            break;
          }

          message.borrowed.push(EntitlementsShared.decode(reader, reader.uint32()));
          continue;
        }
        case 101: {
          if (tag !== 810) {
            break;
          }

          message.lent.push(EntitlementsShared.decode(reader, reader.uint32()));
          continue;
        }
        case 1000: {
          if (tag !== 8002) {
            break;
          }

          message.fabricUsage.push(EntitlementFabricUsage.decode(reader, reader.uint32()));
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): EntitlementUsage {
    return {
      level: isSet(object.level) ? entitlementLevelFromJSON(object.level) : 0,
      availableBalance: isSet(object.availableBalance) ? globalThis.Number(object.availableBalance) : 0,
      totalEntitled: isSet(object.totalEntitled) ? globalThis.Number(object.totalEntitled) : 0,
      allocatedTo: isSet(object.allocatedTo) ? globalThis.Number(object.allocatedTo) : 0,
      borrowed: globalThis.Array.isArray(object?.borrowed)
        ? object.borrowed.map((e: any) => EntitlementsShared.fromJSON(e))
        : [],
      lent: globalThis.Array.isArray(object?.lent) ? object.lent.map((e: any) => EntitlementsShared.fromJSON(e)) : [],
      fabricUsage: globalThis.Array.isArray(object?.fabricUsage)
        ? object.fabricUsage.map((e: any) => EntitlementFabricUsage.fromJSON(e))
        : [],
    };
  },

  toJSON(message: EntitlementUsage): unknown {
    const obj: any = {};
    if (message.level !== 0) {
      obj.level = entitlementLevelToJSON(message.level);
    }
    if (message.availableBalance !== 0) {
      obj.availableBalance = Math.round(message.availableBalance);
    }
    if (message.totalEntitled !== 0) {
      obj.totalEntitled = Math.round(message.totalEntitled);
    }
    if (message.allocatedTo !== 0) {
      obj.allocatedTo = Math.round(message.allocatedTo);
    }
    if (message.borrowed?.length) {
      obj.borrowed = message.borrowed.map((e) => EntitlementsShared.toJSON(e));
    }
    if (message.lent?.length) {
      obj.lent = message.lent.map((e) => EntitlementsShared.toJSON(e));
    }
    if (message.fabricUsage?.length) {
      obj.fabricUsage = message.fabricUsage.map((e) => EntitlementFabricUsage.toJSON(e));
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<EntitlementUsage>, I>>(base?: I): EntitlementUsage {
    return EntitlementUsage.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<EntitlementUsage>, I>>(object: I): EntitlementUsage {
    const message = createBaseEntitlementUsage();
    message.level = object.level ?? 0;
    message.availableBalance = object.availableBalance ?? 0;
    message.totalEntitled = object.totalEntitled ?? 0;
    message.allocatedTo = object.allocatedTo ?? 0;
    message.borrowed = object.borrowed?.map((e) => EntitlementsShared.fromPartial(e)) || [];
    message.lent = object.lent?.map((e) => EntitlementsShared.fromPartial(e)) || [];
    message.fabricUsage = object.fabricUsage?.map((e) => EntitlementFabricUsage.fromPartial(e)) || [];
    return message;
  },
};

function createBaseEntitlementsShared(): EntitlementsShared {
  return { level: 0, count: 0 };
}

export const EntitlementsShared: MessageFns<EntitlementsShared> = {
  encode(message: EntitlementsShared, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.level !== 0) {
      writer.uint32(8).int32(message.level);
    }
    if (message.count !== 0) {
      writer.uint32(16).uint32(message.count);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): EntitlementsShared {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseEntitlementsShared();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break;
          }

          message.level = reader.int32() as any;
          continue;
        }
        case 2: {
          if (tag !== 16) {
            break;
          }

          message.count = reader.uint32();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): EntitlementsShared {
    return {
      level: isSet(object.level) ? entitlementLevelFromJSON(object.level) : 0,
      count: isSet(object.count) ? globalThis.Number(object.count) : 0,
    };
  },

  toJSON(message: EntitlementsShared): unknown {
    const obj: any = {};
    if (message.level !== 0) {
      obj.level = entitlementLevelToJSON(message.level);
    }
    if (message.count !== 0) {
      obj.count = Math.round(message.count);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<EntitlementsShared>, I>>(base?: I): EntitlementsShared {
    return EntitlementsShared.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<EntitlementsShared>, I>>(object: I): EntitlementsShared {
    const message = createBaseEntitlementsShared();
    message.level = object.level ?? 0;
    message.count = object.count ?? 0;
    return message;
  },
};

function createBaseEntitlementFabricUsage(): EntitlementFabricUsage {
  return { fabricId: "", fabricName: "", level: 0, usage: [] };
}

export const EntitlementFabricUsage: MessageFns<EntitlementFabricUsage> = {
  encode(message: EntitlementFabricUsage, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.fabricId !== "") {
      writer.uint32(10).string(message.fabricId);
    }
    if (message.fabricName !== "") {
      writer.uint32(18).string(message.fabricName);
    }
    if (message.level !== 0) {
      writer.uint32(24).int32(message.level);
    }
    for (const v of message.usage) {
      EntitlementModelUsage.encode(v!, writer.uint32(802).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): EntitlementFabricUsage {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseEntitlementFabricUsage();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.fabricId = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.fabricName = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 24) {
            break;
          }

          message.level = reader.int32() as any;
          continue;
        }
        case 100: {
          if (tag !== 802) {
            break;
          }

          message.usage.push(EntitlementModelUsage.decode(reader, reader.uint32()));
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): EntitlementFabricUsage {
    return {
      fabricId: isSet(object.fabricId) ? globalThis.String(object.fabricId) : "",
      fabricName: isSet(object.fabricName) ? globalThis.String(object.fabricName) : "",
      level: isSet(object.level) ? entitlementLevelFromJSON(object.level) : 0,
      usage: globalThis.Array.isArray(object?.usage)
        ? object.usage.map((e: any) => EntitlementModelUsage.fromJSON(e))
        : [],
    };
  },

  toJSON(message: EntitlementFabricUsage): unknown {
    const obj: any = {};
    if (message.fabricId !== "") {
      obj.fabricId = message.fabricId;
    }
    if (message.fabricName !== "") {
      obj.fabricName = message.fabricName;
    }
    if (message.level !== 0) {
      obj.level = entitlementLevelToJSON(message.level);
    }
    if (message.usage?.length) {
      obj.usage = message.usage.map((e) => EntitlementModelUsage.toJSON(e));
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<EntitlementFabricUsage>, I>>(base?: I): EntitlementFabricUsage {
    return EntitlementFabricUsage.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<EntitlementFabricUsage>, I>>(object: I): EntitlementFabricUsage {
    const message = createBaseEntitlementFabricUsage();
    message.fabricId = object.fabricId ?? "";
    message.fabricName = object.fabricName ?? "";
    message.level = object.level ?? 0;
    message.usage = object.usage?.map((e) => EntitlementModelUsage.fromPartial(e)) || [];
    return message;
  },
};

function createBaseEntitlementModelUsage(): EntitlementModelUsage {
  return { model: 0, pid: "", totalBound: 0, allocated: 0, borrowed: 0, needed: 0, compliant: false };
}

export const EntitlementModelUsage: MessageFns<EntitlementModelUsage> = {
  encode(message: EntitlementModelUsage, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.model !== 0) {
      writer.uint32(8).int32(message.model);
    }
    if (message.pid !== "") {
      writer.uint32(18).string(message.pid);
    }
    if (message.totalBound !== 0) {
      writer.uint32(80).uint32(message.totalBound);
    }
    if (message.allocated !== 0) {
      writer.uint32(88).uint32(message.allocated);
    }
    if (message.borrowed !== 0) {
      writer.uint32(96).uint32(message.borrowed);
    }
    if (message.needed !== 0) {
      writer.uint32(104).uint32(message.needed);
    }
    if (message.compliant !== false) {
      writer.uint32(112).bool(message.compliant);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): EntitlementModelUsage {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseEntitlementModelUsage();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break;
          }

          message.model = reader.int32() as any;
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.pid = reader.string();
          continue;
        }
        case 10: {
          if (tag !== 80) {
            break;
          }

          message.totalBound = reader.uint32();
          continue;
        }
        case 11: {
          if (tag !== 88) {
            break;
          }

          message.allocated = reader.uint32();
          continue;
        }
        case 12: {
          if (tag !== 96) {
            break;
          }

          message.borrowed = reader.uint32();
          continue;
        }
        case 13: {
          if (tag !== 104) {
            break;
          }

          message.needed = reader.uint32();
          continue;
        }
        case 14: {
          if (tag !== 112) {
            break;
          }

          message.compliant = reader.bool();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): EntitlementModelUsage {
    return {
      model: isSet(object.model) ? sbpModelFromJSON(object.model) : 0,
      pid: isSet(object.pid) ? globalThis.String(object.pid) : "",
      totalBound: isSet(object.totalBound) ? globalThis.Number(object.totalBound) : 0,
      allocated: isSet(object.allocated) ? globalThis.Number(object.allocated) : 0,
      borrowed: isSet(object.borrowed) ? globalThis.Number(object.borrowed) : 0,
      needed: isSet(object.needed) ? globalThis.Number(object.needed) : 0,
      compliant: isSet(object.compliant) ? globalThis.Boolean(object.compliant) : false,
    };
  },

  toJSON(message: EntitlementModelUsage): unknown {
    const obj: any = {};
    if (message.model !== 0) {
      obj.model = sbpModelToJSON(message.model);
    }
    if (message.pid !== "") {
      obj.pid = message.pid;
    }
    if (message.totalBound !== 0) {
      obj.totalBound = Math.round(message.totalBound);
    }
    if (message.allocated !== 0) {
      obj.allocated = Math.round(message.allocated);
    }
    if (message.borrowed !== 0) {
      obj.borrowed = Math.round(message.borrowed);
    }
    if (message.needed !== 0) {
      obj.needed = Math.round(message.needed);
    }
    if (message.compliant !== false) {
      obj.compliant = message.compliant;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<EntitlementModelUsage>, I>>(base?: I): EntitlementModelUsage {
    return EntitlementModelUsage.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<EntitlementModelUsage>, I>>(object: I): EntitlementModelUsage {
    const message = createBaseEntitlementModelUsage();
    message.model = object.model ?? 0;
    message.pid = object.pid ?? "";
    message.totalBound = object.totalBound ?? 0;
    message.allocated = object.allocated ?? 0;
    message.borrowed = object.borrowed ?? 0;
    message.needed = object.needed ?? 0;
    message.compliant = object.compliant ?? false;
    return message;
  },
};

type Builtin = Date | Function | Uint8Array | string | number | boolean | undefined;

export type DeepPartial<T> = T extends Builtin ? T
  : T extends globalThis.Array<infer U> ? globalThis.Array<DeepPartial<U>>
  : T extends ReadonlyArray<infer U> ? ReadonlyArray<DeepPartial<U>>
  : T extends {} ? { [K in keyof T]?: DeepPartial<T[K]> }
  : Partial<T>;

type KeysOfUnion<T> = T extends T ? keyof T : never;
export type Exact<P, I extends P> = P extends Builtin ? P
  : P & { [K in keyof P]: Exact<P[K], I[K]> } & { [K in Exclude<keyof I, KeysOfUnion<P>>]: never };

function isSet(value: any): boolean {
  return value !== null && value !== undefined;
}

export interface MessageFns<T> {
  encode(message: T, writer?: BinaryWriter): BinaryWriter;
  decode(input: BinaryReader | Uint8Array, length?: number): T;
  fromJSON(object: any): T;
  toJSON(message: T): unknown;
  create<I extends Exact<DeepPartial<T>, I>>(base?: I): T;
  fromPartial<I extends Exact<DeepPartial<T>, I>>(object: I): T;
}
